export default __webpack_public_path__ + "static/media/cs-new-user-flow-th.61af34e0.png";